var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"7"}},[_c('div',{key:_vm.$store.getters['resource/currentResource'].key,staticClass:"white-container"},[(_vm.loading)?_c('loader'):_c('form-fields',{staticClass:"px-2",attrs:{"formColumns":12,"fields":_vm.fields,"labelBlockWith":4,"mb":4},on:{"submit":_vm.createPartner}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }